import { render, staticRenderFns } from "./return_list.vue?vue&type=template&id=1666e0f2"
import script from "./return_list.vue?vue&type=script&lang=js"
export * from "./return_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports